import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { SuccessOutline, CloseOutline } from '@olist/design-system-icons';
import { StyledFilterBadge } from './styles.js';

const FilterBadge = (_a) => {
    var { children, selected, disabled, id, isOpen = true, showIcon = true, onChange, onClose } = _a, props = __rest(_a, ["children", "selected", "disabled", "id", "isOpen", "showIcon", "onChange", "onClose"]);
    return isOpen ? (React.createElement(StyledFilterBadge, Object.assign({ selected: selected, disabled: disabled, htmlFor: id }, props),
        !onClose && (React.createElement("input", { type: "checkbox", checked: selected, onChange: onChange, disabled: disabled, id: id })),
        selected && showIcon && React.createElement(SuccessOutline, null),
        children,
        onClose && (React.createElement("button", { onClick: onClose },
            React.createElement(CloseOutline, null))))) : null;
};

export { FilterBadge as default };
